import React, { useEffect, useState } from "react";
import HeaderBar from "../HeaderBar/HeaderBar";
import "./HeaderNavContainer.css";
import MenuBar from "../MenuBar/MenuBarIdentity";
import { MenuBarProvider } from "../../contexts/menuBar";

const HeaderNavContainer = () => {
	const [showMenu, setShowMenu] = useState(true);

	useEffect(() => {
		let screenWidth = document.documentElement.clientWidth;
		if (screenWidth < 1024) setShowMenu(false);
	}, []);

	const handleMobileMenuClick = () => {
		setShowMenu(!showMenu);
	};

	return (
		<React.Fragment>
			{/* <HeaderBar handleMobileMenuClick={() => handleMobileMenuClick()} /> */}
			<MenuBarProvider>
				<MenuBar
					className={showMenu ? "show-nav" : "hide-nav"}
					hideMenu={() => setShowMenu(false)}
					handleMobileMenuClick={() => handleMobileMenuClick()}
				/>
			</MenuBarProvider>
		</React.Fragment>
	);
};

export default HeaderNavContainer;
